module.exports = __webpack_public_path__ + "vue/img/log2.22c325b7.png";